<template>
  <div :class="['e-btn-group type-btn-group', { 'hidden': isCampaignFlow }]">
    <ejs-button
      :css-class="`e-outline ${activeType === SAVED_VIEW_TYPE ? 'e-active' : 'button'}`"
      @click.native="getTypeTemplates(SAVED_VIEW_TYPE)"
    >
      Saved
    </ejs-button>
    <ejs-button
      id="prebuilt"
      :css-class="`e-outline ${activeType === PREBUILT_VIEW_TYPE ? 'e-active' : 'button'}`"
      @click.native="getTypeTemplates(PREBUILT_VIEW_TYPE)"
    >
      Pre-Built
    </ejs-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PREBUILT_VIEW_TYPE, SAVED_VIEW_TYPE } from '../../constants/general'
export default {
  name: 'PreBuiltSwitcher',
  data () {
    return {
      PREBUILT_VIEW_TYPE,
      SAVED_VIEW_TYPE
    }
  },
  computed: {
    ...mapGetters({
      activeType: 'getActiveType'
    }),
    isCampaignFlow () {
      return this.$router.currentRoute.name === 'TemplateBuilder' && this.$route.query.isSearchingTemplate === 'true'
    }
  },
  methods: {
    getTypeTemplates (name = '') {
      this.$emit('onChangeType', name)
    }
  }
}
</script>

<style lang="scss" scoped>
// Pre-bulit colors
$type-button-label: #242559;
$type-button-border: #7E80CB;

.type-btn-group {
  .e-btn.e-outline {
    border-color: $type-button-border;
    color: $type-button-label;
  }
  .e-btn.e-outline:hover {
    background-color: $white;
  }
  .e-btn.e-outline.e-active {
    box-shadow: none;
    color: $white;
    background-color: $type-button-label;
  }
  &.hidden {
      visibility: hidden;
  }
}
</style>
